import useGetProjectByIdOverview from '@/api/queries/project/useGetProjectByIdOverview';
import { useUserHasPermission } from '@/hooks/usePermissions';
import {
  AssigneeFilter,
  ListedTimelogs,
  ListedTimelogsContextProvider,
  TypeFilter,
} from '@/ui/components/timelogs/listedTimelogs/listedTimelogsContext';
import CreateEditTimelogSidebar from '@/ui/pages/projectPage/components/LabourPanel/CreateEditTimelogSidebar';
import DeleteTimelogModal from '@/ui/pages/projectPage/components/LabourPanel/DeleteTimelogModal';
import { Button, ManageableItemsList, Tooltip } from '@payaca/ambrosia';

import { TimelogsPermissions } from '@payaca/permissions/timelogs/timelogs.permissions';
import React, { FC } from 'react';
import { useParams } from 'react-router';

export const LabourActualCard: FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  const { project } = useGetProjectByIdOverview(projectId);

  const canCreate = useUserHasPermission({
    permissions: [
      TimelogsPermissions.CREATE_TIMELOGS,
      TimelogsPermissions.CREATE_SELF_ASSIGNED_TIMELOGS,
    ],
  });

  return (
    <ListedTimelogsContextProvider
      linkedEntity={{
        id: projectId,
        type: 'PROJECT',
      }}
      pageSize={100}
    >
      {(state) => (
        <>
          <ManageableItemsList>
            <ManageableItemsList.HeaderBar
              heading="Actuals"
              buttons={
                <Tooltip
                  enabled={!canCreate}
                  tooltipContent="You don't have permission to perform this action"
                >
                  <Button
                    variant="white"
                    size="sm"
                    onClick={
                      canCreate
                        ? () =>
                            state.openDialog({
                              type: 'createTimelog',
                            })
                        : undefined
                    }
                    disabled={!canCreate}
                  >
                    Record timelog
                  </Button>
                </Tooltip>
              }
            />

            <ManageableItemsList.ActionBar>
              <AssigneeFilter />
              <TypeFilter />
            </ManageableItemsList.ActionBar>

            <ListedTimelogs />
          </ManageableItemsList>

          {project && (
            <CreateEditTimelogSidebar
              projectId={projectId}
              isOpen={
                state.activeDialog?.type === 'createTimelog' ||
                state.activeDialog?.type === 'editTimelog'
              }
              timelog={
                state.activeDialog?.type === 'editTimelog'
                  ? state.activeDialog.timelog
                  : undefined
              }
              onClose={() => state.closeDialog()}
              primaryLinkedEntity={{
                entityType: 'deal',
                entityId: +project.id,
              }}
            />
          )}

          <DeleteTimelogModal
            projectId={projectId}
            isOpen={state.activeDialog?.type === 'deleteTimelog'}
            timelogId={
              state.activeDialog?.type === 'deleteTimelog'
                ? state.activeDialog.timelog.id
                : undefined
            }
            onClose={() => state.closeDialog()}
          />
        </>
      )}
    </ListedTimelogsContextProvider>
  );
};
